import { ORDERBYTE_MENU_JSON_ID } from "./orderProductDetail.js";

export const PARSED_MENU_JSON_ID = "restogpt-parsed-menu";

export function injectParsedMenuPayload(pageHtml, payload) {
  const safe = JSON.stringify(payload).replace(/</g, "\\u003c");
  const script = `<script type="application/json" id="${PARSED_MENU_JSON_ID}">${safe}</script>`;
  let page = String(pageHtml || "");

  if (page.includes(`id="${PARSED_MENU_JSON_ID}"`)) {
    page = page.replace(
      new RegExp(
        `<script type="application/json" id="${PARSED_MENU_JSON_ID}">[\\s\\S]*?<\\/script>`
      ),
      script
    );
  } else if (/<\/body>/i.test(page)) {
    page = page.replace(/<\/body>/i, `${script}</body>`);
  } else {
    page = `${page}${script}`;
  }
  return page;
}

export function readEmbeddedParsedMenu(html) {
  const src = String(html || "");

  const unified = src.match(
    new RegExp(
      `<script[^>]+id="${PARSED_MENU_JSON_ID}"[^>]*>([\\s\\S]*?)<\\/script>`,
      "i"
    )
  );
  if (unified) {
    try {
      const data = JSON.parse(unified[1]);
      if (Array.isArray(data?.items) && data.items.length) {
        return { items: data.items, meta: data.meta || null, source: "unified" };
      }
    } catch {
      // fall through
    }
  }

  const legacy = src.match(
    new RegExp(
      `<script[^>]+id="${ORDERBYTE_MENU_JSON_ID}"[^>]*>([\\s\\S]*?)<\\/script>`,
      "i"
    )
  );
  if (legacy) {
    try {
      const data = JSON.parse(legacy[1]);
      if (Array.isArray(data?.items) && data.items.length) {
        return {
          items: data.items,
          meta: { strategies: ["orderbyte-modal"] },
          source: "orderbyte-legacy",
        };
      }
    } catch {
      return null;
    }
  }

  return null;
}
